<template>
  <div>
    <a-form-model :colon="false" :form="form" :label-col="{span:8}" :model="menu" :rules="rules" :wrapper-col="{span:16}" style="margin-left: -12%;margin-right: 50%">
      <a-row>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.menuId')">
            <vxe-input v-model="menu.id" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.parentMenu')">
            <vxe-input v-model="menu.parent.name" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.menuNo')">
            <vxe-input v-model="menu.no" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.menuName')">
            <vxe-input v-model="menu.name" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.url')">
            <vxe-input v-model="menu.url" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.icon')">
            <vxe-input v-model="menu.icon" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.application')">
            <vxe-select v-model="menu.application" :options="applications" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item label="组件名">
            <vxe-input v-model="menu.parameter.component" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item label="组件描述">
            <vxe-input v-model="menu.parameter.meta.title" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item label="组件图标">
            <vxe-input v-model="menu.parameter.meta.icon" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item label="组件参数">
            <vxe-card>
              <!--              <a-form-model :colon="false" layout="vertical" :label-col="{span:8}" :model="menu.parameter.business" :wrapper-col="{span:16}">-->
              <!--                <a-col-->
              <!--                  span="24"-->
              <!--                />-->
              <!--              </a-form-model>-->
              <vxe-form :data="menu.parameter.business">
                <vxe-form-item
                  v-for="item in parameterItems"
                  v-if="menu.parameter.business && menu.parameter.business[item.key]!==undefined"
                  :key="item.key"
                  :field="item.field"
                  :itemRender="item.itemRender"
                  :span="item.span || 24"
                  :title="item.title"
                />
              </vxe-form>
            </vxe-card>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.menuOrdinal')">
            <vxe-number-input v-model="menu.ordinal" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.reportNo')">
            <vxe-input v-model="menu.query.name" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.available')" :label-col="{span:16}" :wrapper-col="{span:8}">
            <vxe-switch v-model="menu.available"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.leaf')" :label-col="{span:16}" :wrapper-col="{span:8}">
            <vxe-switch v-model="menu.leaf"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import { findAll, findOne, save } from '@/api/Api'
import { Menu } from '@/api/dto/menu/Menu'
import { getDictionaries, getEnums, getOptions } from '@/utils/util'

export default {
  name: 'MenuDetail',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      menu: new Menu(),
      applications: [],
      orderTypes: [],
      positionTypes: [],
      rules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        application: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  created() {
    findAll('orderTypeFactory', { available: true }).then(res => {
      if (res.success) {
        this.orderTypes = getOptions(res.result)
      }
      return getDictionaries('POSITION_TYPE')
    }).then(result => {
      this.positionTypes = result
      return getEnums('Application')
    }).then(result => {
      this.applications = result
    })
  },
  computed: {
    parameterItems() {
      return [
        {
          key: 'obtainType',
          field: 'obtainType',
          title: 'business.label.obtainType',
          span: 24,
          itemRender: {
            name: 'VxeInput'
          }
        },
        {
          key: 'pageType',
          field: 'pageType',
          title: 'business.label.pageType',
          span: 24,
          itemRender: {
            name: 'VxeNumberInput'
          }
        },
        {
          key: 'entire',
          field: 'entire',
          title: 'business.label.entire',
          span: 24,
          itemRender: {
            name: 'VxeSwitch'
          }
        },
        {
          key: 'autoReview',
          field: 'autoReview',
          title: 'business.label.autoReview',
          span: 24,
          itemRender: {
            name: 'VxeSwitch'
          }
        },
        {
          key: 'orderType',
          field: 'orderType.id',
          title: 'business.label.orderType',
          span: 24,
          itemRender: {
            name: 'VxeSelect',
            options: this.orderTypes
          }
        },
        {
          key: 'positionType',
          field: 'positionType.id',
          title: 'business.label.positionType',
          span: 24,
          itemRender: {
            name: 'VxeSelect',
            options: this.positionTypes
          }
        },
        {
          key: 'positionTypeIds',
          field: 'positionTypeIds',
          title: 'business.label.positionType',
          span: 24,
          itemRender: {
            name: 'VxeSelect',
            options: this.positionTypes,
            props: {
              multiple: true
            }
          }
        }
      ]
    }
  },
  methods: {
    fetch(id) {
      this.loading = true
      findOne('menuFactory', { id: id }).then(res => {
        if (res.success) {
          this.menu = new Menu(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const menu = this.menu.toJSONObject()
      save('menuPersister', menu).then(res => {
        if (res.success) {
          this.menu = new Menu(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
        }
      }).finally(() => this.loading = false)
    },
    addChildMenu(selectedKey) {
      if (selectedKey.id === null || selectedKey.id === undefined) {
        return this.$notification['error']({
          message: '错误',
          description: '请选择父级节点',
          duration: 4
        })
      }
      this.form.resetFields()
      this.menu = new Menu()
      this.menu.parent = selectedKey
    },
    addMenu(selectedParentKey) {
      this.form.resetFields()
      const newData = new Menu()
      this.menu = Object.assign({}, newData)
      this.form.setFieldsValue({ 'parent.id': selectedParentKey })
    },
    refresh() {
      this.menu = []
      this.form.resetFields()
    }
  }
}
</script>